import { IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import SearchIcon from '@mui/icons-material/Search';
// import MoreVertIcon from '@mui/icons-material/MoreVert';
import './ChatListHeader.scss';
import ChatIcon from '@mui/icons-material/Chat';

interface ChatListHeaderProps {
  onBackClick?: () => void;
  showBackButton?: boolean;
}

const ChatListHeader = ({ onBackClick, showBackButton = false }: ChatListHeaderProps) => {
  return (
    <div className="chat-list-header">
      <div className="chat-list-header__left">
        {showBackButton && onBackClick && (
          <IconButton 
            onClick={onBackClick} 
            className="chat-list-header__back-button"
            aria-label="Go back"
            size="medium"
          >
            <ArrowBackIcon />
          </IconButton>
        )}
        <ChatIcon/>
        <h1 className="chat-list-header__title">Messages</h1>
      </div>
      
      <div className="chat-list-header__actions">
        {/* Commenting search and more buttons as of now */}
        {/* <IconButton 
          className="chat-list-header__action-button"
          aria-label="Search messages"
          size="medium"
        >
          <SearchIcon />
        </IconButton>

         <IconButton 
          className="chat-list-header__action-button"
          aria-label="More options"
          size="medium"
        >
          <MoreVertIcon />
        </IconButton> */}
      </div>
    </div>
  );
};

export default ChatListHeader;

